import { useSelector } from 'react-redux';
import { getIsLoggedInSelector } from '@americanexpress/travel-selectors';
import { v4 as generateUUID } from 'uuid';
import { ignoreHeadersByKey } from 'fetchye';
import { useErrorOnUnexpectedStatusFetchye } from '@americanexpress/fetchye-amex';
import {
  getKytContextApiUrlSelector,
} from '../selectors/getContextApiSelectors';
import {
  TLS_ONLINE_CLIENT_ID,
} from '../constants/travelerDataConstants';
import { fetchyeReporter } from '../utils/fetchyeReporterUtil';
import { useIsCenturionContext } from '../context/isCenturionContext';
import { useFeatureFlagWithProperties } from '../thunks/useFeatureFlagWithProperties';
import { ABANDON_CART_FF } from '../constants/oneXpConstants';
import { useAccountToken } from './useMembershipDataHook';
import { ENC_HIPED } from '../constants/pathnameConstants';

const generateHeaders = () => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  clientId: TLS_ONLINE_CLIENT_ID,
  correlationId: generateUUID(),
});

const getPayload = (accountToken) => ({
  context: [{
    code: 'REQUESTED_CONTEXT',
    value: 'CARTABANDON',
  }],
  card: {
    cardNumber: accountToken,
    type: ENC_HIPED,
  },
});

const useContextAPI = () => {
  const accountToken = useAccountToken();
  const hasDisplayAbandonHotel = useFeatureFlagWithProperties(ABANDON_CART_FF);
  const isCenturion = useIsCenturionContext();
  const isLoggedIn = useSelector(getIsLoggedInSelector);
  const contextApiUrl = useSelector(getKytContextApiUrlSelector);

  const options = {
    method: 'POST',
    defer: !isLoggedIn || !hasDisplayAbandonHotel || isCenturion || !accountToken,
    headers: generateHeaders,
    body: JSON.stringify(getPayload(accountToken)),
    credentials: 'include',
    mapOptionsToKey: ignoreHeadersByKey(['correlationId']),
  };
  const fetcherOpts = {
    expectedStatuses: [200],
    reporting: fetchyeReporter({ component: 'useContextAPI' }),
  };
  const {
    isLoading: contextLoading,
    data: contextResponse,
    error: contextError,
    run,
  } = useErrorOnUnexpectedStatusFetchye(contextApiUrl, options, fetcherOpts);

  return {
    isLoading: contextLoading,
    data: contextResponse?.body,
    error: contextError,
    run,
  };
};

export const useAbandonCartData = () => {
  const {
    isLoading, data, error, run,
  } = useContextAPI();

  return {
    isLoading,
    data: data?.cartAbandon || {},
    error,
    run,
  };
};
